<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="prologue"></a><a id="page_ix">Prologue</a></h2><a id="page_ix">
<p class="noindent"><span class="txit">The sea gives, and the sea takes away. The sea gave me a great deal, but fickle as it is, it tried to steal it back, and nearly me with it.</span></p>
<p class="indent"><span class="txit">I had never been to the ocean before the year I turned thirteen. Until then I had grown up landlocked, where the only nearby water was a municipal swimming pool that burned my eyes red and turned my hair green. My brother and I lived with our mother in a safe, snug triangle: Mom was the base, and my brother and I were the sides that balanced upon her. We laughed a lot then, and I expected to go on that way forever, but the balance shifted suddenly, and everything changed.</span></p>
</a><p class="imagec"><a id="page_ix"><img alt="Images" height="69" src="images/f00ix-01.jpg" width="85"/></a><a id="page_xi"></a></p><a id="page_xi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// prologue.vue?79e036e8